export const whitelabelConfig = {
  short: 'moveen',
  assetUrl: '/whitelabel/moveen/',
  iconUrl: '/img/icons/moveen/',
  storeName: 'Moveen',
  company: 'we-are.travel GmbH',
  analyticsId: 'G-W3635N927T', //ga4
  analyticsType: 'gtag', //should be 'gtag', 'ua' or 'both'
  logoHeader:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/moveen/moveen-logo.svg',
  logoFooter:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/moveen/moveen-logowhite.svg',
  // logoHeader: () => require('@/assets/ooesb-logo.png'),
  // logoFooter: () => require('@/assets/ooesb-logo.png'),
  isStandalone: false,
  showHeader: true,
  showHeaderLogo: false,
  showFooterLogo: false,
  fixedNavbar: false,
  heroTitle: 'Special Deals',
  hasHeroSubtitle: true,
  heroSubtitle: 'clever & günstig mit Urlaubsgutschein',
  supportMail: 'specialdeals@moveen.shop',
  supportPhone: '+39 0473 861 887',
  hasHeroAddition: false,
  showPromoNotification: false,
  showReduction: true,
  heroHomeOnly: true,
  hasCookieConsent: false,
  hasNewsletterOptin: false,
  campaignsEnabled: true,
  heroImageResolution: {
    xl: {width: 2560, height: 500, crop: 'smart'},
    l: {width: 1200, height: 500, crop: 'smart'},
    m: {width: 1024, height: 500, crop: 'smart'},
    s: {width: 960, height: 300, crop: 'east'},
    xs: {width: 700, height: 200, crop: 'centre'},
  },
  hasOfferCta: true,
  hide5sup: true,
  heroInfoText: 'Sparen Sie bis zu 70% für Ihren Kurzurlaub.',
  homepage: {
    advantages: false,
  },
  // locales: [
  //   {
  //     text: 'Deutsch',
  //     value: 'de',
  //   },
  //   {
  //     text: 'Italiano',
  //     value: 'it',
  //   },
  // ],
  styleOverride: () =>
    import(
      /* webpackPrefetch: true */

      /* webpackPreload: true */ '@/styles/styles-moveen.scss'
    ),
}
